import { useSyncExternalStore } from "react";

// The globally selected perspective (lens). Route loaders read it when
// building query variables, so it lives in localStorage rather than React
// context; the navbar switcher writes it and invalidates the router.
const KEY = "cxcash.perspectiveId";

const listeners = new Set<() => void>();

export function getPerspectiveId(): string | null {
  return localStorage.getItem(KEY);
}

export function setPerspectiveId(id: string | null) {
  if (id) {
    localStorage.setItem(KEY, id);
  } else {
    localStorage.removeItem(KEY);
  }
  for (const listener of listeners) listener();
}

export function usePerspectiveId(): string | null {
  return useSyncExternalStore(
    (callback) => {
      listeners.add(callback);
      return () => listeners.delete(callback);
    },
    () => getPerspectiveId()
  );
}

// Bumped whenever the set of perspectives changes (create/rename/delete)
// so the navbar switcher refetches its list instead of serving the Relay
// cache from page load.
let perspectivesVersion = 0;

export function bumpPerspectivesVersion() {
  perspectivesVersion += 1;
  for (const listener of listeners) listener();
}

export function usePerspectivesVersion(): number {
  return useSyncExternalStore(
    (callback) => {
      listeners.add(callback);
      return () => listeners.delete(callback);
    },
    () => perspectivesVersion
  );
}
